import { Component, Injector, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AbstractComponent, ContactGroup, ContactGroupService, ConfirmationComponent, Pager, ContactGroupEditComponent } from 'lib-trend-core';
import { Observable, Subject, debounceTime, distinctUntilChanged, mergeMap, switchMap } from 'rxjs';
import { ContactGroupListComponent } from './contact-group-list/contact-group-list.component';

@Component({
    selector: 'contact-group-component',
    templateUrl: 'contact-group.v2.component.html',
    // templateUrl: 'contact-group.component.html'
    styleUrls: ['contact-group.v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactGroupComponent extends AbstractComponent implements OnInit {

  pager: Pager<ContactGroup> = new Pager<ContactGroup>({ perPage: 15 });
  listObservable: Observable<Pager<ContactGroup>>;
  private termoDaBusca: Subject<string> = new Subject<string>();
  private totalContacts!: Array<any>;
  @Input() toggleTableCard: boolean = false;

  constructor(
    injector: Injector,
    public dialog: MatDialog,
    public contactGroupService: ContactGroupService,
  ) {
    super(injector);
    this.createForm();
  }

  ngOnInit(): void {
    this.getList();
  }

  private createForm(): void {
    this.formGroup = this.formBuilder.group({
      name: [null],
    });
  }

  loadPage(page: number) {
    this.pager.page = page;
    this.getList();
  }

  setupObservableSearch() {
    this.listObservable = this.termoDaBusca
      .pipe(debounceTime(500))
      .pipe(distinctUntilChanged())
      .pipe(switchMap(term => {
        return this.contactGroupService.getAll(this.pager.page, this.pager.perPage, this.searchString, this.searchParams);
      }));
    this.listObservable.subscribe((pager: Pager<ContactGroup>) => {
      this.pager = pager;
    });
  }

  search(termo: string) {
    this.pager.page = 1;
    this.searchString = termo;
    this.termoDaBusca.next(termo);
  }


  getList() {
    this.searchParams = {
      company: this.getIDCurrentCompany(),
    };
    this.contactGroupService.getAll(this.pager.page, this.pager.perPage, this.searchString, this.searchParams).pipe(
      mergeMap((pager: Pager<ContactGroup>) => {
        this.pager = pager;
        const idsContacts = this.pager.list.map(group => group._id);
        return this.contactGroupService.getCountContactsByGroup(idsContacts);
      }),
    ).subscribe((value: any) => {
      this.totalContacts = value;
    });
  }

  add(): void {
    const dialogRef = this.dialog.open(ContactGroupEditComponent, {
      width: '600px'
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getList();
    });
  }

  edit(item: ContactGroup): void {
    const dialogRef = this.dialog.open(ContactGroupEditComponent, {
      width: '600px',
      data: item
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getList();
    });
  }

  delete(item: ContactGroup): void {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      width: '500px',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (Boolean(result) === true) {
        this.contactGroupService.delete(item._id).subscribe({
          next: () => {
            this.getList();
            this.alertService.success(this.t('contactGroup.panel.deleteSuccess'));
          },
          error: err => this.alertService.error(err.error.message)
        })
      }
    });
  }

  getCountContacts(groupId: string): string {
    if (this.totalContacts) {
      const total = this.totalContacts
        .filter((value) => value && value._id === groupId)
        .map((value) => value.totalContacts)
        .toString();

      return total.length === 0
        ? this.t('contactGroup.panel.noParticipants')
        : this.t('contactGroup.panel.participantsCount', { count: total });
    }

    return 'N/A';
  }
  listContactGroup(groupId: string): void {
    this.dialog.open(ContactGroupListComponent, {
      width: '800px',
      data: { groupId }
    });
  }
}
